import gql from 'graphql-tag'
import client from '@stores/apollo'

interface Payload {
  viewer: {
    company: {
      mapping: {
        employeesTagsImportTemplateFile: string
      }
    }
  }
}

export default async function template(): Promise<string> {
  try {
    const { data } = await client.gql.query<Payload>({ query })
    return data.viewer.company.mapping.employeesTagsImportTemplateFile
  } catch (e) {
    console.log(e)
    return ''
  }
}

const query = gql`
  query EmployeesTagsImportTemplate {
    viewer {
      company {
        mapping {
          employeesTagsImportTemplateFile
        }
      }
    }
  }
`
